var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileProjectsLogo = function SvgMobileProjectsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1_23)",
    d: "M6.25 4.333c0-.583.308-1.12.807-1.412L11.693.218a1.6 1.6 0 0 1 1.614 0l4.636 2.703c.5.291.807.83.807 1.412v6.347l-6.25 3.643-6.25-3.643z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1_23)",
    d: "M6.25 10.68c-1.81 1.062-3.628 2.112-5.443 3.17-.5.291-.807.83-.807 1.412v5.405c0 .582.308 1.12.807 1.412l4.636 2.703c.5.29 1.115.29 1.614 0l5.443-3.17v-7.288z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_1_23)",
    d: "M24.193 13.85c.5.29.807.83.807 1.412v5.405c0 .582-.308 1.12-.807 1.412l-4.636 2.703c-.5.29-1.115.29-1.614 0l-5.443-3.17v-7.288l6.25-3.644c1.811 1.062 3.629 2.112 5.443 3.17"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_1_23)",
    d: "M6.25 11.15c0-.29.154-.56.404-.706l5.443-3.173a.8.8 0 0 1 .807 0l5.442 3.173c.25.146.404.415.404.706v6.347c0 .291-.154.56-.404.706l-5.442 3.173a.8.8 0 0 1-.807 0l-5.443-3.173a.82.82 0 0 1-.404-.706z",
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_23",
    x1: 6.25,
    x2: 18.806,
    y1: 3.401,
    y2: 10.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_23",
    x1: 12.5,
    x2: -0.056,
    y1: 14.318,
    y2: 21.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_23",
    x1: 12.5,
    x2: 25.056,
    y1: 14.317,
    y2: 21.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_23",
    x1: 12.5,
    x2: 12.5,
    y1: 7.162,
    y2: 21.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
};
export default SvgMobileProjectsLogo;